import styled from "styled-components";
import { colors } from "../../../../assets";

export const RequestsContainer = styled.div`
  .left-info-modal-main-content {
    .left-info-modal-button {
      .ghost {
        background-color: #fff;
        border: 1px solid ${colors["PR-001-80"]} !important;
        color: ${colors["PR-001-80"]} !important;

        &:hover {
          background-color: #fff;
          border: 1px solid ${colors["PR-001-100"]} !important;
          color: ${colors["PR-001-100"]} !important;
        }
      }
    }
  }

  .requests-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 75px;
  }

  .mediators {
    width: 50%;
    padding: 2em;
  }
`;

export const SectionContainer = styled.section``;
